import { useInfluencerFeatureAccess } from '../hooks/useInfluencerFeatureAccess';
import UpgradePrompt from './UpgradePrompt';

const DEFAULT_COPY = {
  [undefined]: {
    title: 'Upgrade required',
    description:
      'This feature is part of Insta Tools Premium. Upgrade to unlock DM automation, affiliate links, and link management.',
  },
};

const FEATURE_COPY = {
  automation_dm: {
    title: 'Instagram automation is a paid feature',
    description:
      'Upgrade to Insta Tools Premium to create DM automations, analyze comments, and grow your audience on autopilot.',
  },
  affiliate_link: {
    title: 'Affiliate links require Insta Tools Premium',
    description:
      'Generate campaign affiliate links and track performance with the Premium plan.',
  },
  link_management: {
    title: 'Link management requires Insta Tools Premium',
    description:
      'Create and manage your bio link page with the Insta Tools Premium plan.',
  },
};

const FeatureGate = ({ feature, children, fallback }) => {
  const { allowed } = useInfluencerFeatureAccess(feature);
  const copy = FEATURE_COPY[feature] || DEFAULT_COPY[undefined];

  if (allowed) {
    return children;
  }

  if (fallback) {
    return fallback;
  }

  return <UpgradePrompt title={copy.title} description={copy.description} />;
};

export default FeatureGate;
